// import { useState } from 'react';
// import Select from 'react-select';
// import { IoCaretUpOutline, IoCaretDownOutline } from 'react-icons/io5';

// const ReactSelectDropdown = ({
//   options,
//   value,
//   onChange,
//   name,
//   placeholder,
//   idKey,
//   displayKey,
//   disabled,
//   getOptionDisabled,
//   onMenuOpen,
//   onMenuClose,
//   enableScrollEffect = false,
// }) => {

//   const [isSelectOpen, setIsSelectOpen] = useState(false);

//   const selectOptions = options.map(option => ({
//     value: option[idKey],
//     label: option[displayKey],
//     isDisabled: getOptionDisabled
//       ? getOptionDisabled(option)
//       : option.disabled || false,
//   }));

//   const selectedOption =
//     selectOptions.find(opt => opt.value === value) || null;

//   const handleChange = (selected) => {
//     onChange({
//       target: {
//         name,
//         value: selected ? selected.value : ''
//       }
//     });
//   };


//   const handleMenuOpen = () => {
//     setIsSelectOpen(true);

//     if (!enableScrollEffect) return;

//     setTimeout(() => {
//       const mainContainer = document.querySelector('.main_container');
//       const dropdown = document.querySelector(
//         `.routing_select-box .react-select__menu`
//       );
//       console.log("Dropdown element:", dropdown);
//       const dropdownHeight = dropdown?.offsetHeight || 20;
//       const gap = 20;
//       console.log("dropdownHeight", dropdownHeight);
//       if (mainContainer) {
//         mainContainer.style.paddingBottom = dropdownHeight === 120 ? `70px` : `${dropdownHeight + gap}px`;
//         mainContainer.scrollTo({
//           top: mainContainer.scrollHeight,
//           behavior: 'smooth',
//         });
//       }
//     }, 100);
//   };

//   const handleMenuClose = () => {
//     setIsSelectOpen(false);

//     if (!enableScrollEffect) return;

//     const mainContainer = document.querySelector('.main_container');
//     if (mainContainer) {
//       mainContainer.style.paddingBottom = '';
//     }
//   };

//   const defaultOption = {
//     value: '',
//     label: '--Select--',
//     isDisabled: false
//   };

//   const finalOptions = [...selectOptions];


//   return (
//     <>
//       {/* <div className="select-container_list"> */}
//       <Select
//         options={finalOptions}
//         value={selectedOption || defaultOption}
//         onChange={handleChange}
//         placeholder={placeholder || '--Select--'}
//         isDisabled={disabled}
//         getOptionDisabled={(option) => option.isDisabled}
//         className="routing_select-box"
//         classNamePrefix="react-select"
//         //classNamePrefix="react-select"
//         // onMenuOpen={() => {
//         //   setIsSelectOpen(true);
//         //   onMenuOpen && onMenuOpen();
//         // }}
//         // onMenuClose={() => {
//         //   setIsSelectOpen(false);
//         //   onMenuClose && onMenuClose();
//         // }}
//         onMenuOpen={handleMenuOpen}
//         onMenuClose={handleMenuClose}
//         styles={{
//           control: (base, state) => ({
//             ...base,
//             alignItems: 'center',
//             cursor: 'pointer',
//             borderColor: state.isFocused ? '#e4e4e4' : base.borderColor,
//             boxShadow: 'none',
//             '&:hover': {
//               borderColor: '#cfcfcf',
//             },
//           }),
//           valueContainer: (base) => ({
//             ...base,
//             whiteSpace: 'normal',   // ✅ allow wrapping
//             overflow: 'hidden',
//             color: '#465a64',
//           }),

//           singleValue: (base) => ({
//             ...base,
//             whiteSpace: 'normal',   // ✅ wrap text
//             overflow: 'visible',
//             textOverflow: 'unset',
//             position: 'relative',
//             transform: 'none',
//             top: '0',
//             lineHeight: '1.3',
//             color: '#465a64',
//           }),
//         }}
//         components={{ SingleValue: CustomSingleValue }}

//       />

//       <div className="routing_icon-container" sty>

//         {isSelectOpen ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
//       </div>
//       {/* </div> */}
//     </>
//   );
// };

// export default ReactSelectDropdown;


import { useState } from 'react';
import Select from 'react-select';
import { IoCaretUpOutline, IoCaretDownOutline } from 'react-icons/io5';
import CustomSingleValue from '../common/CustomSingleValue';


const ReactSelectDropdown = ({
  options,
  value,
  onChange,
  name,
  placeholder,
  idKey,
  displayKey,
  disabled,
  getOptionDisabled,
  onMenuOpen,
  onMenuClose,
  enableScrollEffect = false,
}) => {

  const [isSelectOpen, setIsSelectOpen] = useState(false);

  const selectOptions = options.map(option => ({
    value: option[idKey],
    label: option[displayKey],
    isDisabled: getOptionDisabled
      ? getOptionDisabled(option)
      : option.disabled || false,
  }));

  const selectedOption =
    selectOptions.find(opt => opt.value === value) || null;

  const handleChange = (selected) => {
    onChange({
      target: {
        name,
        value: selected ? selected.value : ''
      }
    });
  };


  const handleMenuOpen = () => {
    setIsSelectOpen(true);

    if (!enableScrollEffect) return;

    setTimeout(() => {
      const mainContainer = document.querySelector('.main_container');
      const dropdown = document.querySelector(
        `.routing_select-box .react-select__menu`
      );
      console.log("Dropdown element:", dropdown);
      const dropdownHeight = dropdown?.offsetHeight || 20;
      const gap = 20;
      console.log("dropdownHeight", dropdownHeight);
      if (mainContainer) {
        mainContainer.style.paddingBottom = dropdownHeight === 120 ? `70px` : `${dropdownHeight + gap}px`;
        mainContainer.scrollTo({
          top: mainContainer.scrollHeight,
          behavior: 'smooth',
        });
      }
    }, 100);
  };

  const handleMenuClose = () => {
    setIsSelectOpen(false);

    if (!enableScrollEffect) return;

    const mainContainer = document.querySelector('.main_container');
    if (mainContainer) {
      mainContainer.style.paddingBottom = '';
    }
  };

  const defaultOption = {
    value: '',
    label: '--Select--',
    isDisabled: false
  };

  const finalOptions = [...selectOptions];


  return (
    <>
      <Select
        options={finalOptions}
        value={selectedOption || defaultOption}
        onChange={handleChange}
        placeholder={placeholder || '--Select--'}
        isDisabled={disabled}
        getOptionDisabled={(option) => option.isDisabled}
        className="routing_select-box"
        classNamePrefix="react-select"
        onMenuOpen={handleMenuOpen}
        onMenuClose={handleMenuClose}
        components={{ SingleValue: CustomSingleValue }}
        styles={{
          control: (base, state) => ({
            ...base,
            alignItems: 'center',
            cursor: 'pointer',
            borderColor: state.isFocused ? '#e4e4e4' : base.borderColor,
            boxShadow: 'none',
            '&:hover': {
              borderColor: '#cfcfcf',
            },
          }),
          singleValue: (base) => ({
            ...base,
            maxWidth: '100%',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'unset', // 🔥 important
            color: '#465a64',
          }),
        }}
      />

      <div className="routing_icon-container" >

        {isSelectOpen ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
      </div>
    </>
  );
};

export default ReactSelectDropdown;